import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '@/environments/environment';
import { buildParamsFromObject } from '@/app/common/utils/http/http';
import { PaginatedResponse } from '@/app/common/utils/pagination/types';
import { VehicleTrackerService } from '../core/service';
import {
  VehicleTrackerMovementFindAllParams,
  VehicleTrackerPosition,
  VehicleTrackerPositionFindAllParams,
  VehicleTrackerStatistics,
  VehicleTrackerStatisticsParams,
  VehicleTrackerSummary,
} from '../core/type';

@Injectable()
export class VehicleTrackerApiService implements VehicleTrackerService {
  private readonly baseUrl = `${environment.apiHost}/tracker`;

  constructor(private http: HttpClient) {}

  findAllPositions(
    filter?: VehicleTrackerPositionFindAllParams,
  ): Observable<PaginatedResponse<VehicleTrackerPosition>> {
    return this.http.get<PaginatedResponse<VehicleTrackerPosition>>(
      `${this.baseUrl}/positions`,
      { params: buildParamsFromObject(filter) },
    );
  }

  findPositionByChassis(
    chassis: string,
  ): Observable<VehicleTrackerPosition> {
    return this.http.get<VehicleTrackerPosition>(
      `${this.baseUrl}/positions/${encodeURIComponent(chassis)}`,
    );
  }

  findMovementsByChassis(
    chassis: string,
    filter?: VehicleTrackerMovementFindAllParams,
  ): Observable<PaginatedResponse<VehicleTrackerPosition>> {
    return this.http.get<PaginatedResponse<VehicleTrackerPosition>>(
      `${this.baseUrl}/movements/${encodeURIComponent(chassis)}`,
      { params: buildParamsFromObject(filter) },
    );
  }

  getStatisticsByChassis(
    chassis: string,
    params: VehicleTrackerStatisticsParams,
  ): Observable<VehicleTrackerStatistics> {
    return this.http.get<VehicleTrackerStatistics>(
      `${this.baseUrl}/statistics/${encodeURIComponent(chassis)}`,
      { params: buildParamsFromObject(params) },
    );
  }

  getSummary(): Observable<VehicleTrackerSummary> {
    return this.http.get<VehicleTrackerSummary>(`${this.baseUrl}/summary`);
  }
}
